import React from 'react';
import ListItem from '../../list-items/ListItem';

import './ReportList.css';

const InputText = React.memo(props=>{
  return(
    <input
      name={props.name}
      type={props.type}
      className={props.className}
      id={props.id}
      size={props.size}
      onChange={props.onChange}
      value={props.value}
      placeholder={props.placeholder}
    />
  )
})

const ReportList = (props) => {
  return (
    <>
      <div className="reportListTit">생성 리포트 목록</div>
      <div className="reportSearch">
        <InputText placeholder="리포트 명 검색" onChange={props.handleSearchInput} value={props.reportFilter} name="textfield" type="text" className="box" id="textfield" size="25" />
        {/* <a onClick={()=>props.handleSearchBtn(JSON.stringify(props.reportLabelData))} className="button purple_line" style={{padding: "5px 15px", marginLeft: "4px"}}>검색</a> */}
        <a onClick={()=>props.handleSearchBtn(JSON.stringify(props.reportLabelData))} className="button purple_line" style={{marginLeft: "4px"}}>검색</a>
      </div>
      <div className="createReportGroup">
        <div className="overflow-component">
          {props.filteredArray.info && props.filteredArray.info.map( (item, index) => 
            <div className="reportGroup">
              <ListItem type={props.filteredArray.type} key={item.name+index} item={item} index={index} handleClick={props.handleClick} />
            </div>
          )}
          {props.filteredArray.nullLabelItem && props.filteredArray.nullLabelItem.map( (item, index) => 
            <ListItem handleClick={props.handleClick} type={props.filteredArray.nullLabelItemType} key={item.name+index} item={item} index={index} />
          )}
        </div>
      </div>      
    </>
  )
}

export default ReportList;